<template>
    <div class="view view--tile-categories">
        <tile-categories-list v-bind:show-filters="{ 'search': true }"
                        v-bind:show-paging="true"
                        v-bind:show-sort="true"
        />
    </div>
</template>

<script>
    import tileCategoriesList from '../../../components/TileCategoriesList.vue';

    export default {
        components: {
            tileCategoriesList
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/tiles/categories/Index.vue